import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';


import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class SavedSearchesService extends BaseHttpService {

    fetch(id: string): Observable<any> {
        return this.http.get(`${Config.API}/saved-search/${id}`)

            .pipe(catchError(this.handleError.bind(this)));
    }


    postSavedSearch(brandId: string, searchModel: any, columns: any= null): Observable<any> {
      _.unset(searchModel, 'searchId');
      const body = JSON.stringify({searchModel: searchModel, columns: columns});
      return this.http.post(Config.API + '/saved-search/' + brandId, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

}
